import { ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getData } from "../../api/api";
import { Pagination } from "antd";

function RetreatsCard({
  id,
  name,
  subtitle,
  description,
  buttonLabel,
  tags,
  startDate,
  location,
  retreatImages,
  imgUrl,
}) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate(`/retreat/${id}`);
      }}
      className="cursor-pointer bg-[#FAF1EB] shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-xl"
    >
      <img
        src={retreatImages && retreatImages[0]?.url}
        alt={name}
        className="w-full h-48 object-cover"
      />
      <div className="p-6 h-max">
        <div className="flex space-x-2 mb-1"> {startDate}</div>
        <h3 className="text-2xl font-bold text-[#8B572A] mb-2 line-clamp-1">
          {name}
        </h3>
        <p className="text-lg font-medium italic text-gray-700 mb-4">
          {subtitle}
        </p>
        <div
          className="ploaded-content line-clamp-3"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <button className="bg-[#8B572A] text-white px-4 py-2 rounded hover:bg-yellow-700">
          More Information
        </button>
      </div>
    </div>
  );
}

function Retreats2() {
  const [retreats, setRetreats] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // Page starts from 0
  const [pageSize, setPageSize] = useState(2); // Page size
  const [totalItems, setTotalItems] = useState(0); // Total items for pagination
  const [searchInput, setSearchInput] = useState(""); // Search input value
  const [searchTerm, setSearchTerm] = useState(""); // Actual search term used for querying
  const [loading, setLoading] = useState(false); // Loading state

  const fetchRetreats = () => {
    setLoading(true);
    getData(
      `retreats?pageSize=${pageSize}&pageNumber=${currentPage}&name=${encodeURIComponent(
        searchTerm
      )}`
    )
      .then((e) => {
        console.log(e.data.pagination.totalRow);
        console.log(e.data.data);
        setRetreats(e.data.data);
        setTotalItems(e.data.pagination.totalRow);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRetreats();
  }, [currentPage, pageSize, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page - 1); // Adjust for zero-based indexing
    setPageSize(pageSize);
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearch = () => {
    setCurrentPage(0); // Reset to first page (index 0) on new search
    setSearchTerm(searchInput); // Update the search term
  };

  return (
    <div className="min-h-screen p-8">
      {/* Search Input */}
      <div className="mb-4 flex">
        <input
          type="text"
          placeholder="Search retreats..."
          value={searchInput}
          onChange={handleSearchInputChange}
          className="border p-2 rounded-l w-full"
        />
        <button
          onClick={handleSearch}
          className="bg-orange-800 text-white px-4 py-2 rounded-r"
        >
          Search
        </button>
      </div>

      {/* Retreats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {retreats.map((retreat, index) => (
          <RetreatsCard key={index} {...retreat} />
        ))}
      </div>
      {/* Pagination */}
      <div className="flex justify-center mt-8">
        <Pagination
          current={currentPage + 1} // Adjust for zero-based indexing
          pageSize={pageSize}
          total={totalItems}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default Retreats2;
